module.exports = __webpack_public_path__ + "static/media/pkm-mat2.681eb1e7.JPG";